import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const FEATURE_NAME = "schoolInfo";
export const PATH_TO_SCHOOL_INFO_STATE = FEATURE_NAME;
export const baseActionsPath = `seneca/${FEATURE_NAME}`;

export const schoolInfoCrudStateConfig: CrudConfig = Object.freeze({
  name: FEATURE_NAME,
  path: `${baseActionsPath}/meta`,
  callTypes: [AllowedCallTypes.FETCH, AllowedCallTypes.UPDATE]
});
